/**
 * 校验邮箱
 * @param email
 * @returns {boolean}
 */
function checkEmail (email) {
  if (!email) {
    return false
  }

  let reg =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  if (reg.test(email.toLowerCase())) {
    return true
  }
  return false
}

/**
 * 校验电话号码
 * @param phone
 * @returns {boolean}
 */
function checkPhone (phone) {
  if (!phone) {
    return false
  }

  let reg = /^(?:(?:\+|00)86)?1\d{10}$/
  if (reg.test(phone)) {
    return true
  }
  return false
}

/**
 * 校验密码
 * @param value
 * @returns {boolean}
 */
function checkPassword (value) {
  if (!value) {
    return false
  }
  const reg = /^(?=.*\d)(?=.*[A-Za-z])([\w!@#$%^&*?]){8,32}$/
  if (reg.test(value)) {
    return true
  }
  return false
}

/*
 * 简单校验验证码
*/

function checkSMSCode(value) {
  if (!value) return false

  if (value?.length < 4) return false

  return true
}


export {
  checkEmail,
  checkPhone,
  checkPassword,
  checkSMSCode,
}

